import DownloadIcon from 'Components/Icons/DownloadIcon'
import { getDocumentDownloadUrlApi } from 'Constants'
import { Context } from 'Context/Context'
import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import QcrLoader from 'Components/Icons/QcrLoader';

function DocumentsOnCaseDetails({caseDetails, name}) {
  const {makeApiCallFunc} = useContext(Context);
  const [downloadingFile, setDownloadingFile] = useState(null);

  // Documents/video used to be stored on S3 with ACL: "public-read", so
  // `f.location` was itself a permanent public download link. Uploads are
  // now private, so a fresh, access-checked, short-lived URL has to be
  // requested for each download instead of linking straight to `location`.
  // fileName is a display label, not guaranteed unique within a case -
  // location is, so it's sent too to disambiguate duplicate filenames.
  const downloadDoc = (fileName, location) => {
      // window.open must happen synchronously inside the click handler or
      // most browsers' popup blockers silently swallow it - calling it
      // from the async success callback below (after the network
      // round-trip for the signed URL) would get blocked far more often
      // than not. Open a blank tab now, point it at the real URL once we
      // have it. Not passing 'noopener' here since the reference is
      // needed to redirect it - opener is cleared manually once done.
      const newTab = window.open('', '_blank');
      setDownloadingFile(fileName);
      makeApiCallFunc(
          getDocumentDownloadUrlApi,
          { caseId: caseDetails?._id, documentTypeName: name, fileName, location },
          ({ data }) => {
              setDownloadingFile(null);
              if (data?.url) {
                  if (newTab) {
                      try { newTab.opener = null; } catch (e) {}
                      newTab.location.href = data.url;
                  } else {
                      // The blank tab itself got blocked - we still have a
                      // valid URL, so fall back to same-tab navigation
                      // rather than just failing.
                      window.location.href = data.url;
                  }
              } else {
                  if (newTab) newTab.close();
                  toast.error('Could not download ' + fileName);
              }
          },
          (error) => {
              setDownloadingFile(null);
              console.log(error);
              if (newTab) newTab.close();
              toast.error('Could not download ' + fileName);
          }
      );
  }

  return (
    <div className='flex flex-col mt-12 mb-10'>
            {caseDetails?.[name]?.length ?
            <>
                <div className='flex'>
                    <div className='w-max text-sky-600 w-[300px]'>{name === "videoDocument" ? "Video statement" : "Documents"}
                    </div>
               
                </div>
            
                <div className='border mt-6'>{caseDetails?.[name]?.map((f, key) => {
                    return(
                            <div className='flex justify-between border-b border-1 text-sm p-2 items-center '>
                                <div className='w-[20px]'>{key +1}.</div>
                                <div className=' text-left lg:w-[320px] w-[200px] truncate
                                '>{f.fileName}</div>
                                <div className="cursor-pointer flex flex-col" onClick={() => downloadingFile ? null : downloadDoc(f.fileName, f.location)}>
                                    {downloadingFile === f.fileName ?
                                    <QcrLoader variant="draw" size={20} />
                                    :
                                    <DownloadIcon/>}
                                </div>
                            </div>
                        )
                })}
                </div>
            </>
            :
            <div className='flex'>
                No {name === "videoDocument" ? "Video statement" : "Documents"} has been uploaded by the client 
            </div>
            }
        </div>
  )
}

export default DocumentsOnCaseDetails
